import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const AmexSmall = (props: FlagsSvgProps) => {
  return (
    <Svg width={36} height={24} viewBox="0 0 36 24" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_4006" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z"
        fill="#0079C1"
      />
      <Path
        d="M4 0V1H32V0V-1H4V0ZM36 4H35V20H36H37V4H36ZM32 24V23H4V24V25H32V24ZM0 20H1V4H0H-1V20H0ZM4 24V23C2.34315 23 1 21.6569 1 20H0H-1C-1 22.7614 1.23858 25 4 25V24ZM36 20H35C35 21.6569 33.6569 23 32 23V24V25C34.7614 25 37 22.7614 37 20H36ZM32 0V1C33.6569 1 35 2.34315 35 4H36H37C37 1.23858 34.7614 -1 32 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_4006)"
      />
      <Path
        d="M7.93431 8.75L5 15.2417H8.51278L8.94826 14.2066H9.94368L10.3792 15.2417H24.9764L25.9542 14.2335L26.8697 15.2417L31 15.25L28.0564 12.0139L31 8.75H26.9338L25.982 9.73953L25.0952 8.75H16.3472L15.596 10.4256L14.8272 8.75H11.3217V9.51309L10.9318 8.75H7.93431ZM8.61401 9.67182H10.3263L12.2726 14.0738V9.67182H14.1484L15.6517 12.8281L17.0372 9.67182H18.9036V14.33H17.7679L17.7586 10.6799L16.103 14.33H15.0871L13.4221 10.6799V14.33H11.0859L10.6429 13.2857H8.25003L7.80803 14.3291H6.55627L8.61401 9.67182ZM19.9426 9.67182H24.5603L25.9727 11.197L27.4306 9.67182H28.843L26.697 12.013L28.843 14.3273H27.3665L25.9542 12.7844L24.4888 14.3273H19.9426V9.67182ZM9.44699 10.46L8.65862 12.3203H10.2344L9.44699 10.46ZM21.0829 10.6363V11.4867H23.6021V12.4344H21.0829V13.3628H23.9085L25.2215 11.9954L23.9643 10.6355H21.0829V10.6363Z"
        fill="white"
      />
    </Svg>
  )
}
